<template>
    <div class="Keikakumeisai_HanbaisakiEntry">
        <div class="Keikakumeisai_HanbaisakiBasicInfo" @click="()=>{OpenHanbaisaki();}">
            <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsUnfold}" /></div>
            <div class="Keikakumeisai_HanbaisakiName">{{ this.HanbaisakiInfo.hanbaisaki }}</div>
            <div class="Keikakumeisai_Hanbaisaki_Basic"><div>出荷時期</div> <div>{{ this.HanbaisakiInfo.release_number }}</div> </div>
            <div class="Keikakumeisai_Hanbaisaki_Basic"><div>売上日</div> <div>{{ this.FormatSalesDate(this.HanbaisakiInfo.salesDate) }}</div></div>
            <div class="Keikakumeisai_Hanbaisaki_Basic"><div>受注数</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.amount < 0}">{{ this.$FormatNumber(this.HanbaisakiInfo.amount) }}</div></div>
            <div class="Keikakumeisai_Hanbaisaki_Basic"><div>売上</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.sales < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.sales) }}</div></div>
            <div class="Keikakumeisai_Hanbaisaki_Basic" :title="'益率: ' + (Math.ceil(HanbaisakiInfo.profitMargin*100)) + '%'"><div>利益</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.profit < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.profit) }}</div></div>
            <div class="Keikakumeisai_Hanbaisaki_Basic"><div>上代</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.price < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.price) }}</div></div>
            <div class="Keikakumeisai_Hanbaisaki_Basic"><div>販売単価</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.retailPrice < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.retailPrice) }}</div></div>
        </div>
        <div :class="{'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_HanbaisakiDataContainer_Open: IsUnfold}">
            
            <div :class="{Keikakumeisai_HanbaisakiDataTypeHeader: true, GrayUnderline: IsTotalCostIncludingUnfold}" @click="()=>{ this.IsTotalCostIncludingUnfold = !this.IsTotalCostIncludingUnfold; }">
                <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalCostIncludingUnfold}" /></div>
                <div class="Keikakumeisai_ExpenseType Keikakumeisai_CostIncluding">原価算入経費</div>
                <div>{{ this.$FormatCurrency(TotalCostPurple) }}</div>
            </div>
            <div :class="{Keikakumeisai_HanbaisakiDataContainer: true, Keikakumeisai_TotalDataContainer_Open: IsTotalCostIncludingUnfold}">
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>仕入額</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.purchaseAmount) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>見本仕入額</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.samplePurchaseAmount) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>関税</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.customs) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>船積経費</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.shippingExpenses) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>本社費</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.headOfficeExpenses) }}</div></div>
            </div>


            <div :class="{Keikakumeisai_HanbaisakiDataTypeHeader: true, GrayUnderline: IsTotalNonCostUnfold}" @click="()=>{ this.IsTotalNonCostUnfold = !this.IsTotalNonCostUnfold; }">
                <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalNonCostUnfold}" /></div>
                <div class="Keikakumeisai_ExpenseType Keikakumeisai_NonCost">原価算入外経費</div>
                <div>{{ this.$FormatCurrency(TotalCostOrange) }}</div>
            </div>
            <div :class="{Keikakumeisai_HanbaisakiDataContainer: true, Keikakumeisai_TotalDataContainer_Open: IsTotalNonCostUnfold}">
                <KeikakumeisaiFoldableCost :Label="'売上ｺﾐｯｼｮﾝ'" :CostItems="[
                    {
                        label: '原型師',
                        value: this.HanbaisakiInfo.comission_sculptor??0
                    },
                    {
                        label: 'PB',
                        value: this.HanbaisakiInfo.comission_pb??0
                    }
                ]" />
                <!-- <div class="Keikakumeisai_HanbaisakiCostTitle">売上ｺﾐｯｼｮﾝ</div>
                <div class="Keikakumeisai_HanbaisakiCostItem"><div>原型師</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.comission_sculptor) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem"><div>PB</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.comission_pb) }}</div></div> -->
                <KeikakumeisaiFoldableCost :Label="'出荷手数料'" :CostItems="[
                    {
                        label: '倉庫',
                        value: this.HanbaisakiInfo.shipping_warehouse??0
                    },
                    {
                        label: 'PB',
                        value: this.HanbaisakiInfo.shipping_pb??0
                    }
                ]" />
                <!-- <div class="Keikakumeisai_HanbaisakiCostTitle">出荷手数料</div>
                <div class="Keikakumeisai_HanbaisakiCostItem"><div>倉庫</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.shipping_warehouse) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem"><div>PB</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.shipping_pb) }}</div></div> -->
                <KeikakumeisaiFoldableCost :Label="'配送料'" :CostItems="[
                    {
                        label: '倉庫',
                        value: this.HanbaisakiInfo.handling_warehouse??0
                    },
                    {
                        label: 'PB',
                        value: this.HanbaisakiInfo.handling_pb??0
                    }
                ]" />
                <!-- <div class="Keikakumeisai_HanbaisakiCostTitle">配送料</div>
                <div class="Keikakumeisai_HanbaisakiCostItem"><div>倉庫</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.handling_warehouse) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem"><div>PB</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.handling_pb) }}</div></div> -->
                <div class="Keikakumeisai_HanbaisakiCostTitle"></div>
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'原型'" :Cost="this.HanbaisakiInfo.prototypeCost ?? 0" />
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'金型'" :Tooltip="'金型代売上比: ' + (Math.ceil(HanbaisakiInfo.moldCostSalesRatio*100)) + '%'" :Cost="this.HanbaisakiInfo.moldCost ?? 0" />
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'著作権料'" :Cost="this.HanbaisakiInfo.copyrightFees ?? 0" />
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'IT/PB EC決済手数料'" :Cost="this.HanbaisakiInfo.fee_it_pb_ec ?? 0" />
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'ｶｰﾄﾞ決済手数料'" :Cost="this.HanbaisakiInfo.fee_cardPayment ?? 0" />
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'ﾃﾞﾊﾞﾝ'" :Cost="this.HanbaisakiInfo.devanning ?? 0" />
                <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'保管料'" :Cost="this.HanbaisakiInfo.fee_storage ?? 0" />
                <!-- <KeikakumeisaiCostItem :class="'GrayUnderline'" style="margin-left: 35px;" :CostName="'原価算入外経費'" :Cost="this.HanbaisakiInfo.nonCostExpenses ?? 0" /> -->

                <!-- <div class="Keikakumeisai_HanbaisakiCostItem"><div>原型</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.prototypeCost) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem" :title="'金型代売上比: ' + (Math.ceil(HanbaisakiInfo.moldCostSalesRatio*100)) + '%'"><div>金型</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.moldCost) }}</div></div> -->
                <!-- <div class="Keikakumeisai_HanbaisakiCostItem"><div>著作権料</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.copyrightFees) }}</div></div> -->
                <!-- <div class="Keikakumeisai_HanbaisakiCostItem"><div>IT/PB EC決済手数料</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.fee_it_pb_ec) }}</div></div> -->
                <!-- <div class="Keikakumeisai_HanbaisakiCostItem"><div>ｶｰﾄﾞ決済手数料</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.fee_cardPayment) }}</div></div> -->
                <!-- <div class="Keikakumeisai_HanbaisakiCostItem"><div>保管料</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.fee_storage) }}</div></div> -->
                <!-- <div class="Keikakumeisai_HanbaisakiCostItem"><div>原価算入外経費</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.nonCostExpenses) }}</div></div> -->
            </div>

            <div :class="{Keikakumeisai_HanbaisakiDataTypeHeader: true, GrayUnderline: IsTotalCostOtherUnfold}" @click="()=>{ this.IsTotalCostOtherUnfold = !this.IsTotalCostOtherUnfold; }">
                <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalCostOtherUnfold}" /></div>
                <div class="Keikakumeisai_ExpenseType Keikakumeisai_OtherCost">共通経費</div>
                <div>{{ this.$FormatCurrency(TotalCostOther) }}</div>
            </div>
            <div :class="{Keikakumeisai_HanbaisakiDataContainer: true, Keikakumeisai_TotalDataContainer_Open: IsTotalCostOtherUnfold}">
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>在庫</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.zaiko) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>Wax管理費</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.WAX) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>PKGﾃﾞｻﾞｲﾝ</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.packageDesign) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>阿蘭さん固定ｺﾐｯｼｮﾝ</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.comission_alan) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>生産ｺﾐｯｼｮﾝ</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.comssion_production) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>出荷ｹｰｽ</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.shippingCase) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>見本品費</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.samplesCost < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.samplesCost) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>配下残</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.subordinates < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.subordinates) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>交換対応分原価</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.replacementCost < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.replacementCost) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;" title="5%"><div>XPHK生産管理</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.XPHK_management < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.XPHK_management) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;" title="5%"><div>見本分生産管理</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.sampleProductionManagement < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.sampleProductionManagement) }}</div></div> 
            </div>

            <div :class="{Keikakumeisai_HanbaisakiDataTypeHeader: true}" @click="()=>{ this.IsOthersUnfold = !this.IsOthersUnfold; }">
                <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsOthersUnfold}" /></div>
                <div class="Keikakumeisai_ExpenseType Keikakumeisai_Other">その他</div>
                <div></div>
            </div>
            <div :class="{Keikakumeisai_HanbaisakiDataContainer: true,  Keikakumeisai_TotalDataContainer_Open: IsOthersUnfold}">
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>原価/pc</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.costPerPiece) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>見本数</div> <div>{{ this.$FormatNumber(this.HanbaisakiInfo.samplesAmount) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>ｱｲﾃﾑ毎利益率</div> <div>{{ Math.ceil(this.HanbaisakiInfo.profitMarginPerItem * 100) }}%</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;" :title="Math.ceil(this.HanbaisakiInfo.numberOfReturns * 100 / this.HanbaisakiInfo.amount)+'%'"><div>交換対応数</div> <div>{{ this.$FormatNumber(this.HanbaisakiInfo.numberOfReturns) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>原価計</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.totalCost < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.totalCost) }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>仕入単価</div> <div>{{ this.$FormatCurrency(this.HanbaisakiInfo.purchasePrice, '$') }}</div></div>
                <div class="Keikakumeisai_HanbaisakiCostItem GrayUnderline" style="margin-left: 35px;"><div>営業総益</div> <div :class="{NegativeCurrency: this.HanbaisakiInfo.grossOperatingProfit < 0}">{{ this.$FormatCurrency(this.HanbaisakiInfo.grossOperatingProfit) }}</div></div>
                
            </div>
        </div>
    </div>
</template>

<script>
import KeikakumeisaiFoldableCost from './KeikakumeisaiFoldableCost.vue';
import KeikakumeisaiCostItem from './KeikakumeisaiCostItem.vue'

export default
{
    components:{
        KeikakumeisaiFoldableCost,
        KeikakumeisaiCostItem
    },
    props: {
        HanbaisakiInfo: Object
    },
    computed:{
        TotalCostOther()
        {
            let result = 0;

            result = this.AddCost(result, this.HanbaisakiInfo.zaiko);
            result = this.AddCost(result, this.HanbaisakiInfo.WAX);
            result = this.AddCost(result, this.HanbaisakiInfo.packageDesign);
            result = this.AddCost(result, this.HanbaisakiInfo.comission_alan);
            result = this.AddCost(result, this.HanbaisakiInfo.comssion_production);
            result = this.AddCost(result, this.HanbaisakiInfo.shippingCase);
            result = this.AddCost(result, this.HanbaisakiInfo.samplesCost);
            result = this.AddCost(result, this.HanbaisakiInfo.subordinates);
            result = this.AddCost(result, this.HanbaisakiInfo.replacementCost);
            result = this.AddCost(result, this.HanbaisakiInfo.XPHK_management);
            result = this.AddCost(result, this.HanbaisakiInfo.sampleProductionManagement);

            return result;
        },
        TotalCostOrange()
        {
            let result = 0;

            result = this.AddCost(result, this.HanbaisakiInfo.comission_sculptor);
            result = this.AddCost(result, this.HanbaisakiInfo.comission_pb);
            result = this.AddCost(result, this.HanbaisakiInfo.shipping_warehouse);
            result = this.AddCost(result, this.HanbaisakiInfo.shipping_pb);
            result = this.AddCost(result, this.HanbaisakiInfo.handling_warehouse);
            result = this.AddCost(result, this.HanbaisakiInfo.handling_pb);
            result = this.AddCost(result, this.HanbaisakiInfo.prototypeCost);
            result = this.AddCost(result, this.HanbaisakiInfo.moldCost);
            result = this.AddCost(result, this.HanbaisakiInfo.copyrightFees);
            result = this.AddCost(result, this.HanbaisakiInfo.fee_it_pb_ec);
            result = this.AddCost(result, this.HanbaisakiInfo.fee_cardPayment);
            result = this.AddCost(result, this.HanbaisakiInfo.devanning);
            result = this.AddCost(result, this.HanbaisakiInfo.fee_storage);
            // result = this.AddCost(result, this.HanbaisakiInfo.nonCostExpenses);

            return result;
        },
        TotalCostPurple()
        {
            let result = 0;

            result = this.AddCost(result, this.HanbaisakiInfo.purchaseAmount);
            result = this.AddCost(result, this.HanbaisakiInfo.samplePurchaseAmount);
            result = this.AddCost(result, this.HanbaisakiInfo.customs);
            result = this.AddCost(result, this.HanbaisakiInfo.shippingExpenses);
            result = this.AddCost(result, this.HanbaisakiInfo.headOfficeExpenses);

            return result;
        }
    },
    methods:{
        FormatSalesDate(salesDate)
        {
            if (typeof(salesDate) !== typeof(Date))
            {
                salesDate = new Date(salesDate);
            }
            return `${salesDate.getFullYear()}年${(salesDate.getMonth() + 1).toString().padStart(2,'0')}月`;
        },
        AddCost(total, cost)
        {
            if (cost === null ||
                cost === undefined)
            {
                return total;
            }

            if (cost < 0)
            {
                cost *= -1;
            }

            return total + cost;
        },
        OpenHanbaisaki()
        {
            this.IsUnfold = !this.IsUnfold;
        }
    },
    data(){
        return{
            IsUnfold: false,
            IsTotalCostIncludingUnfold: false,
            IsTotalNonCostUnfold: false,
            IsTotalCostOtherUnfold: false,
            IsOthersUnfold: false,
        }
    }
}

</script>

<style>
.Keikakumeisai_HanbaisakiEntry
{
    border: 1px solid #ccc;
    margin-bottom: 8px;
    padding: 10px 25px 10px 5px;
}

.Keikakumeisai_HanbaisakiEntry .Keikakumeisai_HanbaisakiBasicInfo
{
    cursor: pointer;
}

.Keikakumeisai_HanbaisakiBasicInfo
{
    display: flex;
    align-items: center;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.Keikakumeisai_HanbaisakiName
{
    background-color: rgb(66, 165, 231);
    border-radius: 20px;
    padding: 4px 10px;
    margin-left: 10px;
    width: 80px;
    text-align: center;
    cursor: pointer;
}

.Keikakumeisai_Hanbaisaki_Basic
{
    flex: 0.4;
    display: flex;
}

.Keikakumeisai_Hanbaisaki_Basic div:first-of-type
{
    flex: 0.8;
    text-align: right;
    color: #888;
}

.Keikakumeisai_Hanbaisaki_Basic div + div
{
    flex: 1.0;
    text-align: right;
}

.Keikakumeisai_HanbaisakiSales
{
    flex: 0.4;
    text-align: right;
}

.Keikakumeisai_HanbaisakiProfit
{
    flex: 0.4;
    text-align: right;
}

.Keikakumeisai_HanbaisakiPrice
{
    flex: 0.4;
    text-align: right;
}

.Keikakumeisai_HanbaisakiSalerPrice
{
    flex: 0.4;
    text-align: right;
}

.Keikakumeisai_HanbaisakiDataContainer
{
    margin-left: 44px;
    max-height: 0px;
    overflow: hidden;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.Keikakumeisai_HanbaisakiDataContainer_Open
{
    max-height: 9999px;
}

.Keikakumeisai_HanbaisakiDataTypeHeader
{
    margin-top: 15px;
    display: flex;
    align-items: center;
}

.Keikakumeisai_HanbaisakiDataTypeHeader div
{
    cursor: pointer;
}

.Keikakumeisai_HanbaisakiDataTypeHeader div:last-of-type
{
    flex: 1;
    text-align: right;
}

.Keikakumeisai_Hanbaisaki_Cost_Others
{
    background-color: rgb(240, 240, 240);
    border-radius: 5px;
    /* display: grid;
    grid-template-columns: auto auto auto auto;
    grid-row-gap: 20px; */
    padding: 10px;
}

.Keikakumeisai_Hanbaisaki_Cost_Purple
{
    background-color: rgb(228, 223, 236);
    border-radius: 5px;
    /* display: grid;
    grid-template-columns: auto auto auto auto;
    grid-row-gap: 20px; */
    padding: 10px;
}

.Keikakumeisai_HanbaisakiCostTitle
{
    grid-column: 1 / 5;
    margin-bottom: 4px;
    font-size: 1.1rem;
}

.Keikakumeisai_HanbaisakiCostItem
{
    display: flex;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    /* display: block;
    text-align: center; */
}

.Keikakumeisai_HanbaisakiCostItem:hover
{
    background-color: #f8f8f8;
}

.Keikakumeisai_HanbaisakiCostItem div:last-of-type
{
    flex: 1;
    text-align: right;
}

.Keikakumeisai_HanbaisakiCostItem + .Keikakumeisai_HanbaisakiCostTitle
{
    margin-top: 15px;
}

.Keikakumeisai_Hanbaisaki_Cost_Orange
{
    background-color: rgb(253, 233, 217);
    border-radius: 5px;
    /* display: grid;
    grid-template-columns: auto auto auto auto;
    grid-row-gap: 20px; */
    padding: 10px;
}
</style>